import React from 'react';

const MongoDB_Collection = () => {
  return (
    <div>
      <h1>MongoDB_Collection Component</h1>
      <p>This is the MongoDB_Collection page.</p>
    </div>
  );
};

export default MongoDB_Collection;
